import { useFormik } from 'formik'
import React, { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import * as Yup from 'yup'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import Message from '../../../components/Message'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import Input from '../../../components/v2/Input'
import MovingPrice from '../../../components/v2/MovingPrice'
import PhoneNumberInput from '../../../components/v2/PhoneNumberInput'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import Button from '../../../components/v2/buttons/Button'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import BaseModal from '../../../components/v2/modals/BaseModal'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { AldagiApiDataType, GpihApiDataType, InsurerInfo, TravelersInfo } from '../../../domain/types'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { AppState, clearPhoneInfo } from '../../../store/appSlice'
import { AuthState } from '../../../store/authSlice'
import { TravelAbroadState, setInsurerInfo, setOrderId, setTotalPrice } from '../../../store/travelAbroadSlice'
//
//
const PolicyRegistration = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  //
  const { screenHeader, filter, checkout } = useAppSelector(
    (data: { travelAbroad: TravelAbroadState }) => data.travelAbroad,
  )
  //
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const [openNewPassModal, setOpenNewPassModal] = useState<boolean>(false)
  //
  //
  //
  // ! travel policy registration mutation
  const [travelPolicyRegistration, { data: policyRegistrationResponse, isLoading: isPolicyRegistrationLoading }] =
    api.useTravelPolicyRegistrationMutation()
  //
  //
  //
  //  policy registration
  const _policyRegistration = async () => {
    //
    //
    // !FOR GPI CUSTOM DATA
    const holders = filter.offer?.calculatedPrices?.premiumByTravelers?.map(
      ({ guid, travelerBirthday, calculatedPremiumByInsurancesDays }) => {
        //
        //
        return {
          guid,
          travelerBirthday,
          calculatedPremiumByInsurancesDays,
        }
      },
    )
    //
    //
    const gpihApiData: GpihApiDataType = {
      resultHash: filter.offer?.calculatedPrices.resultHash,
      holders: holders,
    }
    //  !FOR GPI CUSTOM DATA

    // !  ALDAGI CUSTOM DATA
    const aldagiHolder = filter.offer?.calculatedPrices?.premiumByTravelers?.map(
      ({ travelerAge, calculatedPremiumByInsurancesDays }) => ({
        travelerAge,
        calculatedPremiumByInsurancesDays,
      }),
    )
    //
    //
    const aldagiApiData: AldagiApiDataType = {
      holders: aldagiHolder,
    }
    //
    //
    const smsToNumber = checkout.insurer.smsCode && parseInt(checkout.insurer.smsCode, 10)
    //
    //
    const travelMultiDays =
      filter?.offer?.calculatedPrices?.travelType === 'multi' ? filter?.offer?.calculatedPrices?.insurancesDays : null
    //
    //
    const promoCode =
      filter.promoCode === '' ? null : filter.discountUsedSuccesfully === false ? null : filter.promoCode
    //
    // for me
    if (checkout.forWho === 'travel-abroad-policy-registration-for-me') {
      //
      //
      if (
        smsToNumber &&
        filter &&
        checkout.insurer.smsCode &&
        checkout.insurer.email &&
        checkout.insurer.phone &&
        checkout.insurer &&
        filter.travelersDate?.[0]?.dateFormat &&
        filter.offer
      ) {
        //
        // insurer Info
        const insurerInfoType: InsurerInfo = {
          translations: checkout.insurer.translations!,
          birthday: filter.travelersDate?.[0]?.dateFormat,
          personalNumber: checkout.insurer.idNumber!,
          gender: checkout.insurer.gender!,
          email: checkout.insurer.email,
          phone: checkout.insurer.phone,
          smsCode: smsToNumber,
          password: checkout.insurer.password,
          franiTerms: {
            consentTerm: checkout.insurer.consentTerm!,
            policyTerm: checkout.insurer.policyTerm!,
            privacyTerm: checkout.insurer.privacyTerm!,
          },
        }
        // insurer info in travelers array
        const travelersInfoType: TravelersInfo[] = [
          {
            translations: checkout.insurer.translations!,
            birthday: filter.travelersDate?.[0]?.dateFormat,
            passportNumber: checkout.insurer.passportNumber!,
            citizenship: checkout.insurer.cityzenship!,
            personalNumber: checkout.insurer.idNumber!,
            insuranceDays: filter.offer.calculatedPrices.insurancesDays,
            gender: checkout.insurer.gender!,
            addons:
              (filter.attachedAddons &&
                filter.attachedAddons.length >= 1 &&
                filter.attachedAddons.map((at) => at.addon.addonId)) ||
              [],

            groupedAddonInfos:
              (filter.groupedAttachedAddons &&
                filter.groupedAttachedAddons?.length >= 1 &&
                filter.groupedAttachedAddons.map((grAt) => grAt.addon.id)) ||
              [],
          },
        ]
        //
        //travel policy registration & for-me
        try {
          await travelPolicyRegistration({
            area: filter.offer.calculatedPrices.area.toUpperCase(),
            promoCode: promoCode,
            compensationCurrency: filter.offer.calculatedPrices.compensationCurrency.toUpperCase(),
            travelType: filter.offer.calculatedPrices.travelType.toUpperCase(),
            compensationLimit: filter.offer.calculatedPrices.compensationLimit,
            sgsVerification: checkout.insurer.sgsVerification!,
            uniqueId: filter.uniqueId!,
            insuranceType: 'for-me',
            startDate: filter.offer.calculatedPrices.startDate,
            endDate: filter.offer.calculatedPrices.endDate,
            travelPackageId: filter.offer.calculatedPrices.travelPackageId,
            insurerInfo: insurerInfoType,
            travelersInfo: travelersInfoType,
            travelMultiDay: travelMultiDays,
            franchise: filter.offer.calculatedPrices.franchise,
            gpihApiData: filter.offer.companySlug === 'gpih' ? gpihApiData : undefined,
            aldagiApiData: filter.offer.companySlug === 'aldagi' ? aldagiApiData : undefined,
            imedilBoolean: filter.offer.companySlug === 'imedi-l' ? true : false,
            betterOffer: filter.betterOffer ?? false,
          }).unwrap()
          //
          // toast.success(`${t('policySuccessfullyRegistered')}`)
          //
          //
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else if (error?.data?.message === 'PROMO_CODE_ERROR') {
            toast.error(`${t('promoCodeCantbeUsed')}`)
          } else {
            toast.error(`${t('anErrorOccurred')}`)
          }
        }
      }
    }
    //
    //
    // for other
    if (checkout.forWho === 'travel-abroad-policy-registration-for-other') {
      //
      const convertDateFormat = (inputDate?: string) => {
        if (inputDate !== undefined) {
          const parts = inputDate.split(' / ')
          if (parts.length === 3) {
            const day = parts[0]
            const month = parts[1]
            const year = parts[2]
            const formattedDate = `${year}-${month}-${day}`
            return formattedDate
          } else {
            return 'Invalid date format'
          }
        }
      }
      //
      const converteInsurerdDate = convertDateFormat(checkout.insurer.dateOfbirth as unknown as string)
      //
      const promoCode =
        filter.promoCode === '' ? null : filter.discountUsedSuccesfully === false ? null : filter.promoCode
      //
      if (
        smsToNumber &&
        filter &&
        checkout.insurer.smsCode &&
        checkout.insurer.email &&
        checkout.insurer.phone &&
        checkout.insurer &&
        filter.offer &&
        converteInsurerdDate &&
        checkout.travelers &&
        checkout.travelers.length >= 1
      ) {
        //
        // insurer Info
        const insurerInfoType: InsurerInfo = {
          translations: checkout.insurer.translations!,
          birthday: converteInsurerdDate,
          personalNumber: checkout.insurer.idNumber!,
          gender: checkout.insurer.gender!,
          email: checkout.insurer.email,
          phone: checkout.insurer.phone,
          smsCode: smsToNumber,
          password: checkout.insurer.password,
          franiTerms: {
            consentTerm: checkout.insurer.consentTerm!,
            policyTerm: checkout.insurer.policyTerm!,
            privacyTerm: checkout.insurer.privacyTerm!,
          },
        }
        //
        //
        //
        const TravelersUnion = [...checkout.travelers]
        //
        //
        //travelers
        const travelersInfoType = TravelersUnion?.map(
          ({
            translations,
            cityzenship,
            gender,
            dateOfbirth,
            passportNumber,
            idNumber,
            addons,
            groupedAddonInfos,
          }) => ({
            translations: translations,
            birthday:
              filter.travelersDate?.find((x) => x.date === (dateOfbirth as any)?.split('-')[0])?.dateFormat ??
              converteInsurerdDate,
            passportNumber: passportNumber,
            citizenship: cityzenship,
            personalNumber: idNumber,
            insuranceDays: filter.offer?.calculatedPrices.insurancesDays,
            gender: gender,
            addons: (addons && addons?.length >= 1 && addons?.map((x) => x.addonId)) || [],
            groupedAddonInfos:
              (groupedAddonInfos && groupedAddonInfos?.length >= 1 && groupedAddonInfos?.map((x) => x.id)) || [],
          }),
        )
        //
        //
        //travel policy registration & for-other
        try {
          await travelPolicyRegistration({
            area: filter.offer.calculatedPrices.area.toUpperCase(),
            promoCode: promoCode,
            compensationCurrency: filter.offer.calculatedPrices.compensationCurrency.toUpperCase(),
            travelType: filter.offer.calculatedPrices.travelType.toUpperCase(),
            compensationLimit: filter.offer.calculatedPrices.compensationLimit,
            sgsVerification: checkout.insurer.sgsVerification!,
            uniqueId: filter.uniqueId!,
            insuranceType: 'for-other',
            startDate: filter.offer.calculatedPrices.startDate,
            endDate: filter.offer.calculatedPrices.endDate,
            travelPackageId: filter.offer.calculatedPrices.travelPackageId,
            insurerInfo: insurerInfoType,
            // @ts-ignore
            travelersInfo: travelersInfoType,
            travelMultiDay: travelMultiDays,
            franchise: filter.offer.calculatedPrices.franchise,
            gpihApiData: filter.offer.companySlug === 'gpih' ? gpihApiData : undefined,
            aldagiApiData: filter.offer.companySlug === 'aldagi' ? aldagiApiData : undefined,
            imedilBoolean: filter.offer.companySlug === 'imedi-l' ? true : false,
            betterOffer: filter.betterOffer ?? false,
          }).unwrap()
          //
          // toast.success(`${t('policySuccessfullyRegistered')}`)
          //
          //
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error(`${t('anErrorOccurred')}`)
          }
        }
      }
    }
    //
    //
    // for me and other
    if (checkout.forWho === 'travel-abroad-policy-registration-for-me-and-other') {
      //
      const promoCode =
        filter.promoCode === '' ? null : filter.discountUsedSuccesfully === false ? null : filter.promoCode
      //
      if (
        smsToNumber &&
        filter &&
        checkout.insurer.smsCode &&
        checkout.insurer.email &&
        checkout.insurer.phone &&
        checkout.insurer &&
        filter.offer &&
        checkout.travelers &&
        checkout.travelers.length >= 1
      ) {
        //
        //
        // insurer Info
        const insurerInfoType: InsurerInfo = {
          translations: checkout.travelers?.[0]?.translations!,
          birthday: filter.travelersDate?.find(
            (x) => x.date === (checkout.travelers?.[0]?.dateOfbirth as any)?.split('-')[0],
          )?.dateFormat as string,
          personalNumber: checkout.travelers?.[0]?.idNumber!,
          gender: checkout.travelers?.[0]?.gender!,
          email: checkout.insurer.email,
          phone: checkout.insurer.phone,
          smsCode: smsToNumber,
          password: checkout.insurer.password,
          franiTerms: {
            consentTerm: checkout.travelers?.[0]?.consentTerm!,
            policyTerm: checkout.insurer.policyTerm!,
            privacyTerm: checkout.insurer.privacyTerm!,
          },
        }
        //
        //
        //travelers
        const travelersInfoType = checkout.travelers?.map(
          ({
            translations,
            cityzenship,
            gender,
            dateOfbirth,
            passportNumber,
            idNumber,
            addons,
            groupedAddonInfos,
          }) => ({
            translations: translations,
            birthday: filter.travelersDate?.find((x) => x.date === (dateOfbirth as any)?.split('-')[0])?.dateFormat,
            passportNumber: passportNumber,
            citizenship: cityzenship,
            personalNumber: idNumber,
            insuranceDays: filter.offer?.calculatedPrices.insurancesDays,
            gender: gender,
            addons: (addons && addons?.length >= 1 && addons?.map((x) => x.addonId)) || [],
            groupedAddonInfos:
              (groupedAddonInfos && groupedAddonInfos?.length >= 1 && groupedAddonInfos?.map((x) => x.id)) || [],
          }),
        )
        //
        //
        //travel policy registration & for-me-and-other
        try {
          await travelPolicyRegistration({
            area: filter.offer.calculatedPrices.area.toUpperCase(),
            promoCode: promoCode,
            compensationCurrency: filter.offer.calculatedPrices.compensationCurrency.toUpperCase(),
            travelType: filter.offer.calculatedPrices.travelType.toUpperCase(),
            compensationLimit: filter.offer.calculatedPrices.compensationLimit,
            sgsVerification: checkout.insurer.sgsVerification ?? false,
            uniqueId: filter.uniqueId!,
            insuranceType: 'for-me-and-other',
            startDate: filter.offer.calculatedPrices.startDate,
            endDate: filter.offer.calculatedPrices.endDate,
            travelPackageId: filter.offer.calculatedPrices.travelPackageId,
            insurerInfo: insurerInfoType,
            // @ts-ignore
            travelersInfo: travelersInfoType,
            travelMultiDay: travelMultiDays,
            franchise: filter.offer.calculatedPrices.franchise,
            gpihApiData: filter.offer.companySlug === 'gpih' ? gpihApiData : undefined,
            aldagiApiData: filter.offer.companySlug === 'aldagi' ? aldagiApiData : undefined,
            imedilBoolean: filter.offer.companySlug === 'imedi-l' ? true : false,
            betterOffer: filter.betterOffer ?? false,
          }).unwrap()
          //
          // toast.success(`${t('policySuccessfullyRegistered')}`)
          //
          //
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error(`${t('anErrorOccurred')}`)
          }
        }
      }

      //
      //
    }
    //
    //
  }
  //
  //
  const setOrderInfoCallBack = useCallback(() => {
    if (policyRegistrationResponse && policyRegistrationResponse.id && policyRegistrationResponse.totalPrice !== null) {
      return [
        dispatch(setOrderId(policyRegistrationResponse.id)),
        dispatch(setTotalPrice(policyRegistrationResponse.totalPrice)),
        navigate('/abroad-payment'),
        dispatch(clearPhoneInfo()),
      ]
    }
    //
    if (policyRegistrationResponse && !policyRegistrationResponse.id) {
      toast.error(`${t('failedToSaveOrderId')}`)
    }
    //
    if (policyRegistrationResponse && policyRegistrationResponse.totalPrice === null) {
      toast.error(`${t('failedToSaveTotalPrice')}`)
    }
    //
  }, [policyRegistrationResponse, dispatch, navigate, t])
  //
  //
  useEffect(() => {
    setOrderInfoCallBack()
    //
    return () => {}
  }, [setOrderInfoCallBack])

  //
  //
  // send verification sms mutation
  const [verificationSms, { isLoading: isverificationSmsNumberLoading, isSuccess: verificationSmsNumberSuccess }] =
    api.useSendVerificationSmsMutation()
  //
  // authorization after mobile verification
  const [authorizationAfterMobileVerification, { data: authSmsVerificationResponse, error: authSmsVerificationError }] =
    api.useAuthorizationAfterMobileVerificationMutation()
  //
  //
  // send verification sms number
  const sendVerificationSmsFunction = async () => {
    if (checkout.insurer.phone && checkout.insurer.email) {
      try {
        //
        await verificationSms({ phone: checkout.insurer.phone }).unwrap()
        //
        toast.success(`${t('smsSuccessfullySent')}`)
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage)
        } else {
          toast.error(`${t('unknownError')} PolicyRegistration.tsx`)
        }
      }
    }
  }
  //
  //
  //
  // authorization after mobile verification
  useEffect(() => {
    if (
      checkout.insurer &&
      checkout.insurer.email &&
      checkout.insurer.phone &&
      checkout.insurer.smsCode &&
      checkout.insurer.smsCode.toString().length === 4
    ) {
      //
      const smsCodeToNumber = parseFloat(checkout.insurer.smsCode)
      const checkAuthorization = async () => {
        try {
          //
          await authorizationAfterMobileVerification({
            email: checkout.insurer.email!,
            phone: checkout.insurer.phone!,
            smsCode: smsCodeToNumber,
            userId: auth.user?.id || 0,
          }).unwrap()
          //
        } catch (error: any) {
          //
          // if sms does not match & clear sms field
          if (error?.data?.errorCode === 'SMS_CODE_DOES_NOT_MATCH') {
            toast.info(error?.data?.errorMessage?.[lang])
          }
          //
          //
          // if user noes not exist
          if (error?.data.errorCode === 'USER_DOES_NOT_EXIST') {
            toast.info(error?.data?.errorMessage?.[lang])
          }
          //
          //
          if (
            auth &&
            auth.user &&
            auth.user?.userType === 'User' &&
            auth.user.email === checkout.insurer.email &&
            auth.user.phone === checkout.insurer.phone
          ) {
            return [
              dispatch(
                setInsurerInfo({
                  fieldName: 'userHaveAccount',
                  fieldValue: true,
                }),
              ),
            ]
          }
        }
      }
      //
      checkAuthorization()
      //
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    authorizationAfterMobileVerification,
    checkout.insurer.email,
    checkout.insurer.phone,
    checkout.insurer.smsCode,
    auth.user?.id,
  ])
  //
  //
  // open password modal
  useEffect(() => {
    if (
      authSmsVerificationError &&
      // @ts-ignore
      authSmsVerificationError?.data?.errorCode === 'USER_DOES_NOT_EXIST' &&
      (auth.user === null || auth.user) &&
      checkout.insurer.smsCode &&
      checkout.insurer.phone &&
      checkout.insurer.email &&
      checkout.insurer.smsCode.length === 4
    ) {
      setOpenNewPassModal(true)
    }
    //

    return () => {}
  }, [auth.user, authSmsVerificationError, checkout.insurer.smsCode, checkout.insurer.phone, checkout.insurer.email])
  //
  //
  // look logged user data
  const setLoggedUserCallBack = useCallback(() => {
    if (auth.user?.phone && auth?.user?.userType === 'User' && auth.user?.email) {
      return [
        dispatch(
          setInsurerInfo({
            fieldName: 'phone',
            fieldValue: auth.user?.phone,
          }),
        ),
        dispatch(
          setInsurerInfo({
            fieldName: 'email',
            fieldValue: auth.user?.email,
          }),
        ),
      ]
    }
  }, [auth?.user?.userType, auth.user?.phone, auth.user?.email, dispatch])
  //
  //
  // set logged user data in rtk store
  useEffect(() => {
    //
    setLoggedUserCallBack()
    //
    return () => {}
  }, [setLoggedUserCallBack])
  //
  //
  //
  //
  // yup validations schema GE
  const ContactValidationSchema = Yup.object({
    email: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      .email(`${t('enterValidMail')}`)
      .required(`${t('required')}`),
    phone: Yup.string()
      .matches(/^\S*$/, `${t('spaceValidation')}`)
      // .min(9, `${t('enterValidPhone')}`)
      // .max(9, `${t('enterValidPhone')}`)
      .required(`${t('required')}`),
    password: Yup.string()
      .min(8, `${t('minPassLenght')}`)
      .matches(/[0-9]/, `${t('passContainNumber')}`)
      .matches(/[a-z]/, `${t('passContainLowerCase')}`)
      .matches(/[a-zA-Z]/, `${t('passContainEnglishLetters')}`)
      .matches(/[A-Z]/, `${t('passContainUpperCase')}`),
    confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], `${t('enterSamePass')}`),
    smsCode: Yup.string()
      .min(4, `${t('enterFourDigitCode')}`)
      .max(4, `${t('enterFourDigitCode')}`)
      .required(`${t('enterFourDigitCode')}`),
  })
  //
  //
  // new user
  useEffect(() => {
    //
    if (
      authSmsVerificationError &&
      (auth.user === null || auth.user) &&
      checkout.insurer.smsCode &&
      checkout.insurer.phone &&
      checkout.insurer.smsCode.length === 4 &&
      checkout.insurer.email &&
      checkout.insurer.password
    ) {
      const new_user = { email: checkout.insurer.email, password: checkout.insurer.password }
      //
      localStorage.setItem('new_user', JSON.stringify(new_user))
    }
    //
    return () => {}
  }, [
    checkout.insurer.password,
    checkout.insurer.email,
    checkout.insurer.phone,
    checkout.insurer.userHaveAccount,
    authSmsVerificationError,
    auth.user,
    checkout.insurer.smsCode,
  ])
  //
  //
  const MainValidationSchema = ContactValidationSchema
  //
  //
  // initial values
  const initialValues = {
    email: checkout.insurer.email || '',
    phone: checkout.insurer.phone || '',
    password: checkout.insurer.password || '',
    confirmPassword: checkout.insurer.confirmPassword || '',
    smsCode: checkout.insurer.smsCode || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: MainValidationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values)
    },
  })
  //
  //
  //
  //
  return isPolicyRegistrationLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('authorization')}</title>
        <meta name="description" content={`${t('authorization')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <BaseModal isOpen={openNewPassModal} onClose={() => setOpenNewPassModal(!openNewPassModal)}>
        <NewAccountModalBlock>
          <h5>{t('simpleRegistration')}</h5>
          <p>{t('createYourAccount')}</p>
          <Input
            id="abroad-policy-registration-password"
            name="abroad-policy-registration-password"
            label={t('enterNewPassword')}
            type="password"
            icon={true}
            placeholder=""
            value={checkout.insurer.password || ''}
            onChange={(value) => [
              dispatch(
                setInsurerInfo({
                  fieldName: 'password',
                  fieldValue: value,
                }),
              ),
              formik.setFieldValue('password', value),
            ]}
            width={'fullWidth'}
            error={formik.errors.password && checkout.insurer.password ? true : false}
            errorText={formik.errors.password}
            onBlur={formik.handleBlur}
            style={{
              marginTop: '24px',
            }}
          />

          <Input
            id="abroad-policy-confirm-registration-password"
            name="abroad-policy-confirm-registration-password"
            label={t('repeatNewPassword')}
            type="password"
            icon={true}
            placeholder=""
            value={checkout.insurer.confirmPassword || ''}
            onChange={(value) => [
              dispatch(
                setInsurerInfo({
                  fieldName: 'confirmPassword',
                  fieldValue: value,
                }),
              ),
              formik.setFieldValue('confirmPassword', value),
            ]}
            width={'fullWidth'}
            error={formik.errors.confirmPassword && checkout.insurer.confirmPassword ? true : false}
            errorText={formik.errors.confirmPassword}
            onBlur={formik.handleBlur}
            style={{
              marginTop: '24px',
            }}
          />

          <Message
            style={{
              marginTop: '10px',
              marginBottom: '0px',
            }}
            variant="gray"
            text={`${t('passwordText')}`}
          />

          <Button
            fullWidth={true}
            style={{
              marginTop: '48px',
            }}
            disabled={
              checkout.insurer.password &&
              checkout.insurer.confirmPassword &&
              checkout.insurer.password === checkout.insurer.confirmPassword &&
              checkout.insurer.consentTerm
                ? false
                : true
            }
            buttonType="primary"
            text={t('registrationAndContinue')}
            onClick={() => {
              if (
                checkout.insurer.password &&
                checkout.insurer.confirmPassword &&
                checkout.insurer.password === checkout.insurer.confirmPassword &&
                checkout.insurer.consentTerm
              ) {
                //
                _policyRegistration()
              }
            }}
          />
        </NewAccountModalBlock>
      </BaseModal>
      {/*  */}
      {/*  */}

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('authorization')} />

        <AbroadProgressBar stepName={`${t('authorization')}`} />

        <MovingPrice price={filter.offerTotalPrice} />

        <WhiteBox>
          <Input
            id="abroad-policy-registration-email"
            name="abroad-policy-registration-email"
            label={`${t('email')}`}
            type="email"
            placeholder=""
            value={checkout.insurer.email || ''}
            onChange={(value) => [
              dispatch(
                setInsurerInfo({
                  fieldName: 'email',
                  fieldValue: value,
                }),
              ),
              formik.setFieldValue('email', value),
            ]}
            width={'fullWidth'}
            error={formik.errors.email && checkout.insurer.email ? true : false}
            errorText={formik.errors.email}
            onBlur={formik.handleBlur}
            disabled={
              checkout.insurer.email &&
              checkout.insurer.phone &&
              checkout.insurer.smsCode &&
              verificationSmsNumberSuccess &&
              checkout.insurer.smsCode.length === 4
                ? true
                : false
            }
          />

          <PhoneNumberInput
            style={{
              marginTop: '24px',
            }}
            id="abroad-policy-registration-phone"
            label={`${t('phone')}`}
            value={checkout.insurer.phone || ''}
            onChange={(value) => [
              dispatch(
                setInsurerInfo({
                  fieldName: 'phone',
                  fieldValue: value,
                }),
              ),
              formik.setFieldValue('phone', value),
            ]}
            resendOnclick={sendVerificationSmsFunction}
            sendSms={sendVerificationSmsFunction}
            error={formik.errors.phone && checkout.insurer.phone ? true : false}
            errorText={formik.errors.phone}
            onBlur={formik.handleBlur}
            hideButtons={false}
            disabled={
              (checkout.insurer.email &&
                checkout.insurer.phone &&
                checkout.insurer.smsCode &&
                verificationSmsNumberSuccess &&
                checkout.insurer.smsCode.length === 4) ||
              isverificationSmsNumberLoading ||
              (policyRegistrationResponse && policyRegistrationResponse.id && policyRegistrationResponse.totalPrice) ||
              formik.errors.email
                ? true
                : false
            }
          />

          {(verificationSmsNumberSuccess && checkout.insurer.phone && checkout.insurer.email) ||
          (checkout.insurer.phone && checkout.insurer.email && checkout.insurer.smsCode) ? (
            <Input
              id="abroad-policy-registration-phone-sms"
              name="abroad-policy-registration-phone=sms"
              label={`${t('smsCode')}`}
              type="number"
              placeholder=""
              value={checkout.insurer.smsCode || ''}
              onChange={(value) => [
                dispatch(
                  setInsurerInfo({
                    fieldName: 'smsCode',
                    fieldValue: value,
                  }),
                ),
                formik.setFieldValue('smsCode', value),
              ]}
              width={'fullWidth'}
              error={formik.errors.smsCode && checkout.insurer.smsCode ? true : false}
              errorText={formik.errors.smsCode}
              onBlur={formik.handleBlur}
              disabled={
                policyRegistrationResponse && policyRegistrationResponse.id && policyRegistrationResponse.totalPrice
                  ? true
                  : false
              }
              style={{
                marginTop: '24px',
              }}
            />
          ) : null}
        </WhiteBox>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => navigate('/abroad-check-information')}
          />

          <NavigationButton
            text={'შემდეგი'}
            buttonType="next"
            disabled={
              (!authSmsVerificationError &&
                checkout.insurer.email &&
                checkout.insurer.phone &&
                checkout.insurer.smsCode &&
                checkout.insurer.smsCode.length === 4) ||
              (authSmsVerificationError &&
                checkout.insurer.email &&
                checkout.insurer.phone &&
                checkout.insurer.smsCode &&
                checkout.insurer.smsCode.length === 4 &&
                checkout.insurer.password &&
                checkout.insurer.confirmPassword &&
                checkout.insurer.password === checkout.insurer.confirmPassword)
                ? false
                : true
            }
            //
            onClick={() => {
              if (
                // if user don't have account & open create password modal & create new user profile
                authSmsVerificationError &&
                (auth.user === null || auth.user) &&
                checkout.insurer.smsCode &&
                checkout.insurer.phone &&
                checkout.insurer.email &&
                checkout.insurer.smsCode.length === 4
              ) {
                setOpenNewPassModal(true)
              }
              //
              //
              if (
                //  if user have account & policy registration
                (authSmsVerificationResponse &&
                  authSmsVerificationResponse.id &&
                  checkout.insurer.email &&
                  checkout.insurer.smsCode) ||
                (checkout.insurer.password &&
                  checkout.insurer.smsCode &&
                  checkout.insurer.smsCode.length === 4 &&
                  formik.isValid)
              ) {
                //
                _policyRegistration()
                //
              }
              //
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//

const NewAccountModalBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h5 {
    font-size: 24px;
    color: ${Colors.primaryBlack};
    text-align: center;
  }
  p {
    text-align: center;
    font-size: 14px;
    color: ${Colors.nevadaGrey};
  }

  ${Responsive.mobile} {
    h5 {
      font-size: 18px;
    }
  }
`

const WhiteBox = styled.div`
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  width: 100%;
  margin-inline: auto;
  border-radius: 8px;
  padding: 48px;

  ${Responsive.mobile} {
    padding: 20px;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
    width: 100%;
  }
`
const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
`
//
export default PolicyRegistration
